import { BASE_URL } from './config';

export const AUTH_LOGIN_URI = `${BASE_URL}/Login`;
export const DASHBOARD_URL = `${BASE_URL}/Dashboard`;

export const SERVICE_ORDER = 'ServiceOrderRequest';
export const TASK = 'ServiceOrderTask';
export const TASK_EDIT = `${SERVICE_ORDER}`;
export const TASK_STATUS_EDIT = `${TASK}`;

export const SERVICE_ORDER_TYPE = 'ServiceOrderType';
export const SERVICE_ORDER_ALL = `${SERVICE_ORDER_TYPE}/GetAll`;
export const SERVICE_ORDER_TEMPLATE = `${SERVICE_ORDER_TYPE}/GetServiceOrderTemplateTasks`;

export const TASK_DETAILS = `${TASK}/Details`;
export const TASK_LIST = `${TASK}/GetByPage`;


export const CONFIG_URL = 'api/v1/Configuration';